<template>
  <div class="app-container">
    <NavTitle :title="title" @titleClick="handleTitle" />

    <!-- 库存管理 -->
    <Page
      v-show="tagStep == 0"
      ref="pageRef"
      :page-pie-info="pagePieInfo"
      @pageTableDetail="pageTableDetail"
    />

    <!-- 批次详情 -->
    <Batch
      v-show="tagStep == 1"
      ref="batchRef"
      @batchTableDetail="batchTableDetail"
    />

    <!-- 往来记录 -->
    <Record v-show="tagStep == 2" ref="recordRef" />
  </div>
</template>

<script>
import * as echarts from "echarts";
import Page from "./components/page";
import Batch from "./components/batch";
import Record from "./components/record";
import NavTitle from "@/components/NavTitle/index.vue";

export default {
  name: "PageInventory",
  components: { Page, Batch, Record, NavTitle },
  data() {
    return {
      title: ["库存管理"],
      tagStep: 0,
      pagePieInfo: {},
      batchStandardCode: "",
      batchEnterpriseName: "",
    };
  },
  created() {},
  mounted() {
    this.fetchData();
  },
  methods: {
    batchTableDetail(value) {
      if (value.type === 0) {
        this.title = ["库存管理", "批次详情", "往来记录"];
      }
      if (value.type === 1) {
        this.title = ["库存管理", "批次详情", "入库记录"];
      }
      if (value.type === 2) {
        this.title = ["库存管理", "批次详情", "出库记录"];
      }
      this.tagStep = 2;
      value.enterpriseName = this.batchEnterpriseName;
      console.log(this.batchEnterpriseName);

      this.$nextTick(async () => {
        await this.$refs.recordRef.pageFetchData(value);
      });
    },
    async pageTableDetail(value) {
      this.title = ["库存管理", "批次详情"];
      this.tagStep = 1;
      this.batchStandardCode = value.standardCode;
      this.batchEnterpriseName = value.enterpriseName;
      this.$nextTick(async () => {
        const circleItems = await this.$refs.batchRef.pageFetchData(
          value.standardCode,
          value.enterpriseName
        );
        this.fetchBatchPie(circleItems);
      });
    },
    handleTitle(value, index) {
      this.tagStep = index;
      this.title.splice(index + 1);
    },
    async fetchData() {
      this.$nextTick(async () => {
        const data = await this.$refs.pageRef.pageFetchData();
        this.pagePieInfo = data;
        this.fetchPagePie(data);
      });
    },
    fetchBatchPie(pageBatchData) {
      const color = ["#1BC88E", "#4076F2", "#FF1616", "#D2D2D2"];
      const userOption = {
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          borderColor: "transparent",
          padding: 0,
          extraCssText:
            "box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3); border-radius: 8px;",
          formatter: (params) => {
            const index = pageBatchData.circleItems.findIndex(
              (item) => item.name === params.name
            );
            const currentColor = color[index] || color[0];
            const currentData = pageBatchData.circleItems[index];
            const valueStr = currentData ? currentData.valueStr : params.value;
            return `
              <div style="padding: 7px 0">
                <div style="font-weight: 500; font-size: 12px; color: #242b35;  margin-left: 12px;">库存总量</div>
                <div style="font-weight: 400; font-size: 11px; color: #666666; margin-left: 12px;">共${pageBatchData.totalValue}</div>
                <div style="display: flex; align-items: center; font-weight: 400; font-size: 12px; color: #242b35; margin-right: 12px; margin-left: 12px;">
                  <div style="width: 5px; height: 5px; border-radius: 50%; margin-right: 10px; background: ${currentColor};"></div>
                  <div style="white-space: nowrap; margin-right:20px;">${params.name}</div>
                  <div style="white-space: nowrap; margin-right:20px; text-align: left;">${valueStr}</div>
                  <div style="white-space: nowrap; text-align: left;">${params.percent}%</div>
                </div>
              </div>
            `;
          },
          position: (point) => point,
        },
        title: {
          text: pageBatchData.total,
          subtext: "库存总量",
          left: "center",
          top: "70",
          textStyle: {
            fontSize: 16,
            color: "#333",
          },
          subtextStyle: {
            fontSize: 12,
          },
        },
        legend: {
          show: false,
        },
        series: [
          {
            type: "pie",
            radius: ["65%", "85%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              disabled: false,
              scale: false,
              label: {
                show: false,
                fontSize: 12,
              },
            },
            labelLine: {
              show: false,
            },
            color: ["#1BC88E", "#4076F2", "#FF1616", "#D2D2D2"],
            data: pageBatchData.circleItems,
          },
        ],
      };
      const e = echarts.init(this.$refs.batchRef.$refs.batchPieRef);
      e.setOption(userOption);
    },
    fetchPagePie(pagePieData) {
      const color = ["#1BC88E", "#4076F2", "#FF1616", "#D2D2D2"];
      const userOption = {
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          borderColor: "transparent",
          padding: 0,
          extraCssText:
            "box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3); border-radius: 8px;",
          formatter: (params) => {
            const index = pagePieData.circleData.findIndex(
              (item) => item.name === params.name
            );
            const currentColor = color[index] || color[0];
            const currentData = pagePieData.circleData[index];
            const valueStr = currentData ? currentData.valueStr : params.value;
            return `
              <div style="padding: 7px 0">
                <div style="font-weight: 500; font-size: 12px; color: #242b35;  margin-left: 12px;">库存总量</div>
                <div style="font-weight: 400; font-size: 11px; color: #666666; margin-left: 12px;">共${pagePieData.totalValue}</div>
                <div style="display: flex; align-items: center; font-weight: 400; font-size: 12px; color: #242b35; margin-right: 12px; margin-left: 12px;">
                  <div style="width: 5px; height: 5px; border-radius: 50%; margin-right: 10px; background: ${currentColor};"></div>
                  <div style="white-space: nowrap; margin-right:20px;">${params.name}</div>
                  <div style="white-space: nowrap; margin-right:20px; text-align: left;">${valueStr}</div>
                  <div style="white-space: nowrap; text-align: left;">${params.percent}%</div>
                </div>
              </div>
            `;
          },
          position: (point) => point,
        },
        title: {
          text: pagePieData.total,
          subtext: "库存总量",
          left: "center",
          top: "70",
          textStyle: {
            fontSize: 16,
            color: "#333",
          },
          subtextStyle: {
            fontSize: 12,
          },
        },
        legend: {
          show: false,
        },
        series: [
          {
            type: "pie",
            radius: ["65%", "85%"],
            avoidLabelOverlap: false,
            width: "100%",
            height: "100%",
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              disabled: false,
              scale: false,
              label: {
                show: false,
                fontSize: 12,
              },
            },
            labelLine: {
              show: false,
            },
            color: ["#1BC88E", "#4076F2", "#FF1616", "#D2D2D2"],
            data: pagePieData.circleData,
          },
        ],
      };
      const e = echarts.init(this.$refs.pageRef.$refs.inventoryPieRef);
      e.setOption(userOption);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
